import { render, staticRenderFns } from "./RegisterPassword.vue?vue&type=template&id=15a0005a&lang=pug&"
import script from "./RegisterPassword.vue?vue&type=script&lang=js&"
export * from "./RegisterPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports